// extracted by mini-css-extract-plugin
module.exports = {"title":"ListPersonFeedback_title__R2fg0","name":"ListPersonFeedback_name__xwR-q","card":"ListPersonFeedback_card__i-ygP"};